import { FormizoSchema } from "Components/LabIZO/Formizo";

const initial: FormizoSchema[] = [
  {
    label: "Initial Watsons also?",
    name: "initialwatsons",
    format: "bool",
    boolStyle: "checkbox",
    defaultValue: true,
  },
  {
    control: "initialwatsons",
    fold: [
      {
        label: "URL",
        name: "Watsons.URL",
        format: "text",
      },
      {
        label: "APIKEY",
        name: "Watsons.APIKEY",
        format: "text",
      },
      {
        label: "Version",
        name: "Watsons.VERSION",
        format: "text",
      },
      {
        label: "EN",
        name: "Watsons.EN",
        format: "text",
      },
      {
        label: "TC",
        name: "Watsons.TC",
        format: "text",
      },
      {
        label: "SC",
        name: "Watsons.SC",
        format: "text",
      },
    ],
  },
  {
    label: "Conversation Log Database",
    name: "ConvDB.type",
    format: "select",
    selectStyle: "dropdown",
    selectRef: "ConvDBTypes",
    selectCap: "caption",
    selectVal: "_id",
    placeholder: "Database Type",
    validate: ["required"],
    options: [
      { value: "CouchDB", label: "BaseDB" },
      { value: "ElasticSearch", label: "Elastic Search" },
    ],
    defaultValue: "ElasticSearch",
  },
  {
    control: "ConvDB.type",
    controlFunc: (doc, field) => doc?.ConvDB?.type === "ElasticSearch",
    fold: [
      {
        label: "Username",
        name: "ConvDB.username",
        format: "text",
      },
      {
        label: "Password",
        name: "ConvDB.password",
        format: "text",
      },
      {
        label: "URL",
        name: "ConvDB.url",
        format: "text",
      },
      {
        label: "Index",
        name: "ConvDB.index",
        format: "text",
      },
      {
        label: "Index Timeframe",
        name: "ConvDB.indexTimeframe",
        format: "select",
        selectStyle: "dropdown",
        selectRef: "IndexTimeframeTypes",
        selectCap: "caption",
        selectVal: "_id",
        placeholder: "Index Timeframe Type",
        validate: ["required"],
      },
    ],
  },
  {
    label: "Initial GPT",
    name: "initialGptQa",
    format: "bool",
    defaultValue: false,
  },
  {
    control: "initialGptQa",
    fold: [
      {
        label: "Type",
        name: "GPTQA.type",
        format: "select",
        options: [
          { value: "openai", label: "OpenAI" },
          { value: "azure", label: "Azure" },
        ],
        defaultValue: "azure",
      },
      {
        label: "control",
        name: "GPTQA.type",
        controlFunc: (doc, field) => doc?.GPTQA?.type === "openai",
        fold: [
          { label: "APIKEY", name: "GPTQA.openai.apiKey", format: "text" },
          { label: "Embedding Model", name: "GPTQA.openai.embedding_model", format: "text", defaultValue: "text-embedding-ada-002" },
          { label: "Generation Model", name: "GPTQA.openai.generation_model", format: "text", defaultValue: "gpt-3.5-turbo" },
        ],
      },
      {
        label: "control",
        name: "GPTQA.type",
        controlFunc: (doc, field) => doc?.GPTQA?.type === "azure",
        fold: [
          { label: "APIKEY", name: "GPTQA.azure.apiKey", format: "text" },
          { label: "URL", name: "GPTQA.azure.url", format: "text" },
          { label: "Embedding Model", name: "GPTQA.azure.embedding_model", format: "text" },
          { label: "Generation Model", name: "GPTQA.azure.generation_model", format: "text" },
        ],
      },
    ],
  },
];
export const schema = {
  initial,
};
